import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  staffListApi,
  logOutApi,
  multipleServicesListApi,
  commissionCreateGroup,
  commissionCreateAPI,
  commissionGroupListAPI,
  commissionGroupUpdateApi,
  commissionGroupDeleteApi,
  commissionListApi,
  commissionDetailsApi,
  commissionUpdateAPI,
  commissionDeleteApi,
} from "../../../../Context/api";
import { statusCodes } from "../../../../Constants/generalConfig";
import { Notifications } from "../../../../App";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const useCommissionStructure = () => {
  const { userInfo } = useContext(Notifications);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [commissionList, setCommissionList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [commissionDetailsList, setCommissionDetailsList] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [teamMember, setTeamMember] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [groupModal, setGroupModal] = useState(false);
  const [groupMode, setGroupMode] = useState("ADD");
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [error, setError] = useState({});
  const [count, setCount] = useState(1)
  const [page, setPage] = useState(1)
  const PER_PAGE = 10
  const [groupForm, setGroupForm] = useState({
    staffId: [],
    groupName: "",
  });

  // const [formData, setFormData] = useState({
  //   structureName: "",
  //   validTo: null,
  //   validFrom: null,
  //   assignTo: "GROUP",
  //   groupId: null,
  //   modelType:'TARGET_BASED',
  //   targetType: "MONTHLY",
  //   tiers: [],
  //   staffId: null,
  //   items: [],
  // });

  const [formData, setFormData] = useState({
  structureName: "",
  validFrom: "",
  validTo: "",
  assignTo: "GROUP",
  groupId: "",
  staffId: "",
  modelType: "TARGET_BASED",
  targetType: "MONTHLY",
  tiers: [],
  items: [],
});

  const navigate = useNavigate();

  const handleOpenGroupModal = () => {
    setGroupModal(true);
  };

  const handleCloseGroupModal = () => {
    setGroupModal(false);
    setGroupForm({
      staffId: [],
      groupName: "",
    });
  };

  const handleOpenAddGroupModal = () => {
    setGroupMode("ADD");
    setEditingGroupId(null);
    setGroupForm({
      groupName: "",
      staffId: [],
    });
    setGroupModal(true);
  };

  const handleOpenEditGroupModal = (group) => {
    setGroupMode("EDIT");
    setEditingGroupId(group._id);
    setGroupForm({
      groupName: group.groupName,
      staffId: group.staffId || [],
    });
    setGroupModal(true);
  };

  const handleGroupSubmit = () => {
    if (!groupForm.groupName.trim()) {
      toast.error("Group Name is required");
      return;
    }

    if (groupMode === "ADD") {
      createGroupApi();
    } else {
      commissionGroupUpdate(editingGroupId);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError((prev) => {
      if (!prev[name]) return prev;
      const updatedErrors = { ...prev };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const handleGrpupChange = (e) => {
    const { name, value } = e.target;
    setGroupForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleStaffToggle = (e, staffId) => {
    const checked = e.target.checked;
    setGroupForm((prev) => ({
      ...prev,
      staffId: checked
        ? [...prev.staffId, staffId]
        : prev.staffId.filter((id) => id !== staffId),
    }));
  };

  const handleServiceChange = (event, values) => {
    const isSelectAll = values.find((v) => v._id === "select-all");

    if (isSelectAll) {
      if (selectedServices.length === serviceList.length) {
        setSelectedServices([]);
        setFormData((prev) => ({ ...prev, services: [] }));
      } else {
        setSelectedServices(serviceList);
        setFormData((prev) => ({ ...prev, services: serviceList }));
      }
    } else {
      setSelectedServices(values);
      setFormData((prev) => ({ ...prev, services: values }));
    }
  };

  const handleAssignTo = (type) => {
    setFormData((prev) => ({
      ...prev,
      assignTo: type,
      groupId: type === "GROUP" ? prev.groupId : null,
      staffId: type === "STAFF" ? prev.staffId : null,
    }));
  };

  const handleAddTier = () => {
    setFormData((prev) => {
      const lastTier = prev.tiers[prev.tiers.length - 1];
      return {
        ...prev,
        tiers: [
          ...prev.tiers,
          {
            id: Date.now().toString(),
            tierName: `Tier ${prev.tiers.length + 1}`,
            targetFrom: lastTier ? lastTier.targetTo : 0,
            targetTo: 0,
            commissionType: "PERCENT",
            commissionValue: 0,
          },
        ],
      };
    });
  };

  const handleRemoveTier = (id) => {
    setFormData((prev) => ({
      ...prev,
      tiers: prev.tiers.filter((t) => t.id !== id),
    }));
  };

  const handleTierChange = (id, field, value) => {
    setFormData((prev) => ({
      ...prev,
      tiers: prev.tiers.map((t) => (t.id === id ? { ...t, [field]: value } : t)),
    }));
  };

  const handleItemChange = (id, field, value) => {
    setFormData((prev) => ({
      ...prev,
      items: prev.items.map((i) => (i.id === id ? { ...i, [field]: value } : i)),
    }));
  };

  const handleRemoveItem = (id) => {
    setFormData((prev) => ({
      ...prev,
      items: prev.items.filter((i) => i.id !== id),
    }));
  };

  const handleAddItem = () => {
    setFormData((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          id: Date.now(),
          itemId: null,
          itemType: "services",
          commissionType: "PERCENT",
          commissionValue: 0,
        },
      ],
    }));
  };

  const handleModelType = (type) => {
    setFormData((prev) => ({
      ...prev,
      modelType: type,
      tiers: type === "TARGET_BASED" ? (prev.tiers.length > 0 ? prev.tiers : [{
        id: Date.now().toString(),
        tierName: "Tier 1",
        targetFrom: 0,
        targetTo: 0,
        commissionType: "PERCENT",
        commissionValue: 0,
      }]) : [],
      items: type === "ITEM_BASED" ? (prev.items.length > 0 ? prev.items : [{
        id: Date.now(),
        itemId: null,
        itemType: "services",
        commissionType: "PERCENT",
        commissionValue: 0,
      }]) : [],
    }));
  };

  useEffect(() => {
    teamMembers();
    servicesList();
    commissionGroupList();
  
  }, []);

  useEffect(()=>{
  commissionListData();
  },[page])

  const logOutFun = () => {
    axios
      .post(
        logOutApi(),
        {
          deviceId: userData.deviceId,
          userId: userData?.userId,
          type: "WEBPROVIDER",
        },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          localStorage.removeItem("userData");
          navigate("/");
        }
      });
  };

  const teamMembers = () => {
    const payload = {
      userId: userData?.providerId,
      isActive: true,
      count: 100,
      isAccepted: "accepted",
      branchId: userData?.locationId,
    };
    axios
      .post(staffListApi(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setTeamMember(resp.data.data || []);
        } else {
          setTeamMember([]);
        }
      })
      .catch(() => setTeamMember([]));
  };

  const servicesList = () => {
    axios
      .post(
        multipleServicesListApi(),
        {
          userId: userData?.userId,
          branchId: userData?.locationId,
        },
        {
          headers: { Authorization: `Bearer ${userData?.token}` },
        }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          const services =
            resp.data.data?.flatMap((category) =>
              category.servicedetails?.map((service) => ({
                _id: service.serviceId,
                name: `${service.serviceName} (${userInfo?.currencySymbol}${service.fixedAmount})`,
                categoryName: category.categoryName,
              }))
            ) || [];

          setServiceList(services);
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        }
      })
      .catch(() => {});
  };

  const createGroupApi = () => {
    setSpinner(true);
    const payload = {
      staffId: groupForm.staffId,
      groupName: groupForm.groupName,
    };
    axios
      .post(commissionCreateGroup(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
          handleCloseGroupModal();
          commissionGroupList();
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const commissionGroupUpdate = (id) => {
    setSpinner(true);
    const payload = {
      staffId: groupForm.staffId,
      groupName: groupForm.groupName,
      id: id,
    };
    axios
      .post(commissionGroupUpdateApi(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
          handleCloseGroupModal();
          commissionGroupList();
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const commissionGroupDelte = (id) => {
    setSpinner(true);
    const payload = {
      isDeleted: true,
      id: id,
    };
    axios
      .post(commissionGroupDeleteApi(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
          commissionGroupList();
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const commissionGroupList = () => {
    const data = {};
    setSpinner(true);
    axios
      .post(
        commissionGroupListAPI(),
        { data },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
          setGroupList(resp.data.data);
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {
        setSpinner(false);
      });
  };

    const commissionDelete = (id) => {
    setSpinner(true);
    const payload = {
      isDeleted: true,
      id: id,
    };
    axios
      .post(commissionDeleteApi(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
            const updatedTotal = count - 1;
        const lastPage = Math.ceil(updatedTotal / PER_PAGE);
          if (page > lastPage && page > 1) {
          setPage(page - 1);
        } else {
          commissionListData();
        }
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const isValid = () => {
    const errorObj = {};
    if (!formData?.structureName) {
      errorObj["structureName"] = "Structure Name is required";
    }
    if (formData.assignTo === "GROUP") {
      if (!formData?.groupId) {
        errorObj.groupId = "Group is required";
      }
    }

    if (formData.assignTo === "STAFF") {
      if (!formData?.staffId) {
        errorObj.staffId = "Team Member is required";
      }
    }
  if (formData.modelType === "ITEM_BASED") {
    const itemErrors = {};

    formData.items.forEach((item, index) => {
      if (!item.itemId) {
        itemErrors[item.id] = "Service is required";
      }
    });

    if (Object.keys(itemErrors).length > 0) {
      errorObj.items = itemErrors;
    }
  }

    setError(errorObj);
    return !Object.keys(errorObj)?.length;
  };

  const commissionCreateApi = () => {
    if (!isValid()) return;
    setSpinner(true);
    const payload = {
      structureName: formData.structureName || null,
      validFrom: moment(formData.validFrom).startOf("day").utc()  || null,
      validTo: moment(formData.validTo).endOf("day").utc()  || null,

      assignTo: formData.assignTo,
      groupId: formData.assignTo === "GROUP" ? formData.groupId : null,
      staffId: formData.assignTo === "STAFF" ? formData.staffId : null,

      modelType: formData.modelType,
      targetType:
        formData.modelType === "TARGET_BASED" ? formData.targetType : null,

      tiers:
        formData.modelType === "TARGET_BASED"
          ? formData.tiers.map(tier => ({
              tierName: tier.tierName,
              targetFrom: Number(tier.targetFrom) || 0,
              targetTo: Number(tier.targetTo) || 0,
              commissionType: tier.commissionType,
              commissionValue: tier.commissionValue || 0
            }))
          : [],

      items:
        formData.modelType === "ITEM_BASED"
          ? formData.items.map(item => ({
              itemId: item.itemId,
              itemType: item.itemType,
              commissionType: item.commissionType,
              commissionValue: item.commissionValue || 0
            }))
          : [],
    };

    axios
      .post(commissionCreateAPI(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
          navigate(-1);
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const commissionUpdateApi = (id) => {
    if (!isValid()) return;
    setSpinner(true);
    const payload = {
      id: id,
      structureName: formData.structureName || null,
      validFrom: moment(formData.validFrom).startOf("day").utc()  || null,
      validTo:  moment(formData.validTo).endOf("day").utc() || null,

      assignTo: formData.assignTo,
      groupId: formData.assignTo === "GROUP" ? formData.groupId : null,
      staffId: formData.assignTo === "STAFF" ? formData.staffId : null,

      modelType: formData.modelType,
      targetType:
        formData.modelType === "TARGET_BASED" ? formData.targetType : null,

      tiers:
        formData.modelType === "TARGET_BASED"
          ? formData.tiers.map(tier => ({
              tierName: tier.tierName,
              targetFrom: tier.targetFrom || 0,
              targetTo: tier.targetTo || 0,
              commissionType: tier.commissionType,
              commissionValue: tier.commissionValue
            }))
          : [],

      items:
        formData.modelType === "ITEM_BASED"
          ? formData.items.map(item => ({
              itemId: item.itemId,
              itemType: item.itemType,
              commissionType: item.commissionType,
              commissionValue: item.commissionValue
            }))
          : [],
    };

    axios
      .post(commissionUpdateAPI(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message);
          navigate(-1);
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
        }
        setSpinner(false);
      })
      .catch(() => setSpinner(false));
  };

  const commissionListData = () => {
    const data = {
      page: page,
      count: PER_PAGE,
    };
    setSpinner(true);
    axios
      .post(
        commissionListApi(),
        data ,
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
          setCommissionList(resp.data.data);
          setCount(resp.data.totalCount)
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {
        setSpinner(false);
      });
  };

  const commissionDetailsData = (id) => {
    setSpinner(true);
    axios
      .post(
        commissionDetailsApi(),
        { id: id },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          const data = resp.data.data;
          setCommissionDetailsList(data);

          // Format dates for input fields
          const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
          };

          // Populate formData with API response
          setFormData({
            structureName: data.structureName || "",
            validFrom: formatDate(data.validFrom),
            validTo: formatDate(data.validTo),
            assignTo: data.assignTo || "GROUP",
            groupId: data.groupId || null,
            staffId: data.staffId || null,
            modelType: data.modelType || null,
            targetType: data.targetType || "MONTHLY",
            tiers: data.tiers?.map((tier, index) => ({
              id: tier.id || Date.now().toString() + index,
              tierName: tier.tierName || `Tier ${index + 1}`,
              targetFrom: tier.targetFrom || 0,
              targetTo: tier.targetTo || 0,
              commissionType: tier.commissionType || "PERCENT",
              commissionValue: tier.commissionValue || 0,
            })) || [],
            items: data.items?.map((item, index) => ({
              id: item.id || Date.now() + index,
              itemId: item.itemId || null,
              itemType: item.itemType || "services",
              commissionType: item.commissionType || "PERCENT",
              commissionValue: item.commissionValue || 0,
            })) || [],
          });

          setSpinner(false);
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {
        setSpinner(false);
        toast.error("Failed to load commission details");
      });
  };

  return {
    data: {
      spinner,
      teamMember,
      formData,
      serviceList,
      selectedServices,
      groupModal,
      groupForm,
      groupList,
      error,
      groupMode,
      commissionList,
      commissionDetailsList,
      PER_PAGE,
      page,
      count,
 
    },
    method: {
      handleChange,
      handleServiceChange,
      handleCloseGroupModal,
      handleOpenGroupModal,
      handleGrpupChange,
      createGroupApi,
      handleStaffToggle,
      commissionCreateApi,
      commissionUpdateApi,
      handleRemoveItem,
      handleAddItem,
      handleItemChange,
      handleTierChange,
      handleRemoveTier,
      handleAddTier,
      setFormData,
      handleModelType,
      handleAssignTo,
      handleGroupSubmit,
      handleOpenEditGroupModal,
      handleOpenAddGroupModal,
      commissionGroupDelte,
      commissionDetailsData,
      commissionDelete,
      setError,
      setPage,
    },
  };
};

export default useCommissionStructure;